<template>
  <div class="py-3 px-2">
    <b-row class="base-row-padded">
      <b-col>
        <h4>Welcome, {{ userData.name }} </h4>
      </b-col>
    </b-row>
    <b-row class="base-row-padded">
      <b-col cols="12" lg="6">
        <b-card class="my-2 mx-1" border-variant="info" header-bg-variant="info"
          no-body header="User information">
          <b-list-group flush>
            <b-list-group-item>
              <small>Role</small>
              <div>{{userData.role.name}}</div>
            </b-list-group-item>
            <b-list-group-item>
              <small>Name</small>
              <div>{{userData.name}}</div>
            </b-list-group-item>
            <b-list-group-item>
              <small>Email</small>
              <div>{{userData.email}}</div>
            </b-list-group-item>
          </b-list-group>
        </b-card>
        <b-card class="my-2 mx-1" border-variant="success" header-bg-variant="success"
          v-if="permission('devices')" no-body header="Device groups">
          <b-list-group flush>
            <b-list-group-item v-for="group in groups" :key="group.id"
              :to="{name: 'showGroup', params: {id: group.id}}">
              <div class="d-flex w-100 justify-content-between">
                <p>{{group.name}}</p>
                <small># of devices: {{group.devices_count}}</small>
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-card>
        <b-card class="my-2 mx-1" border-variant="primary" header-bg-variant="primary"
          v-if="permission('devices')" no-body header="Devices">
          <b-list-group flush>
            <b-list-group-item v-for="device in devices" :key="device.id"
              :to="{name: 'showDevice', params: {id: device.id}}">
              <div class="d-flex w-100 justify-content-between">
                <p>{{device.name}}</p>
                <small>Seen: {{parseDate(device.last_seen)}}</small>
              </div>
              <p>{{device.address}}</p>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>
      <b-col>
        <b-card class="my-2 mx-1" border-variant="warning" header-bg-variant="warning"
          v-if="permission('logs')" no-body header="Short log">
          <b-list-group flush>
            <b-list-group-item v-for="log in logs" :key="log.id"
              :to="{name: 'showLog', params: {id: log.id}}">
              <div class="d-flex w-100 justify-content-between">
                <h5>{{log.log_name}}</h5>
                <small>{{parseDate(log.created_at)}}</small>
              </div>
              <p>{{log.description}}</p>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import rolesMixin from '@/modules/rolesMixin';
import axios from '@/modules/axiosInterceptor';
import { apiUrlPrefix } from '@/modules/staticData';
import datetime from '@/mixins/datetime';

export default {
  mixins: [rolesMixin, datetime],
  data() {
    return {
      logs: [],
      groups: [],
      devices: [],
    };
  },
  created() {
    if (this.permission('logs')) this.fetchLogs();
    if (this.permission('devices')) this.fetchDevices();
    if (this.permission('devices')) this.fetchGroups();
  },
  methods: {
    fetchLogs() {
      axios.get(`${apiUrlPrefix}logs`).then((r) => {
        this.logs = r.data.log.data.filter((e, idx) => idx < 10);
      });
    },
    fetchDevices() {
      axios.get(`${apiUrlPrefix}devices`).then((r) => {
        this.devices = r.data.devices.data.filter((e, idx) => idx < 5);
      });
    },
    fetchGroups() {
      axios.get(`${apiUrlPrefix}groups`).then((r) => {
        this.groups = r.data.groups.data.filter((e, idx) => idx < 5);
      });
    },
  },
};
</script>
